// extracted by mini-css-extract-plugin
export default {"root":"DetailLayoutHeader_root__YsMeQ","title":"DetailLayoutHeader_title__11qXR","back":"DetailLayoutHeader_back__xoOQQ"};